<script>
    import Icon from '../icon/Icon.svelte';

    /**
     * @typedef {Object} OptionGroupProps
     * @property {Array} [choices] - Array with options to present:
     * [ { label, icon, title, click: 'always', value } ]
     * these and all other properties are passed as options to callback.
     * @property {Function} [callback] - function to call when option gets selected.
     * @property {boolean} [doCallbackOnInitialize] - If true, call callback when component is
     * created instead of first waiting for user input.
     * @property {number} [selectedIndex] - Index of item that should be selected by default.
     * @property {boolean} [fullWidth] - If true, stretch component over full width of parent.
     */

     /** @type {OptionGroupProps} */
    let {
        choices,
        callback,
        doCallbackOnInitialize = false,
        selectedIndex = 0,
        fullWidth = false,
    } = $props()

    let previousIndex

    function init() {
        if (doCallbackOnInitialize && callback) {
            callback(choices[selectedIndex], selectedIndex, goToPrevious)
        }
    }

    function changeToIndex(index) {
        if (selectedIndex === index && choices[index].click !== 'always') {
            return
        }

        previousIndex = selectedIndex
        selectedIndex = index

        if (callback) {
            callback(choices[selectedIndex], selectedIndex, goToPrevious)
        }
    }

    export function goToPrevious() {
        if (choices[previousIndex]) {
            changeToIndex(previousIndex)
        }
    }
</script>

<div
    use:init
    class="group"
    class:full-width={fullWidth}
>
    {#each choices as choice, index (index)}
        <button
            class="item"
            class:active={index === selectedIndex}
            title={choice.title}
            onclick={() => changeToIndex(index)}>

            {#if choice.icon}
                <Icon name={choice.icon}></Icon>
            {/if}
            {#if choice.label}
                {choice.label}
            {/if}
            {#if choice.click === 'always'}
                <Icon name="arrow-right"></Icon>
            {/if}

        </button>
    {/each}
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.group {
  display: inline-flex;
  overflow: hidden;
  flex-wrap: wrap;
  background: #fff;
  border: 1px solid hsl(40, 4%, 84%);
  border-radius: 12px;
  color: #122d40;
}
.group.full-width {
  display: flex;
  flex-wrap: nowrap;
}
.group.full-width .item {
  flex-basis: 100%;
}
.group .item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: inherit;
  background-color: transparent;
  user-select: none;
  transition: background-color 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.group .item:hover:not(.active) {
  cursor: pointer;
  background-color: hsl(40, 20%, 96%);
}
.group .item.active {
  color: hsl(205, 60%, 44%);
  background-color: rgba(44.88, 123.42, 179.52, 0.1);
}
.group .item.active :global(svg) {
  fill: currentColor;
}
.group .item :global(svg) {
  display: flex;
  width: 16px;
  height: 16px;
  fill: currentColor;
}</style>
